// Polyfill Buffer for libraries like gray-matter
import { Buffer } from 'buffer';
window.Buffer = Buffer;

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async'; // Import HelmetProvider
import App from './App.tsx';
import './index.css';

// Remove loading screen once app is mounted
const removeLoadingScreen = () => {
  const loadingScreen = document.getElementById('loading-screen');
  if (loadingScreen) {
    loadingScreen.style.opacity = '0';
    setTimeout(() => loadingScreen.remove(), 300);
  }
};

// Measure performance
const observer = new PerformanceObserver((list) => {
  const entries = list.getEntries();
  entries.forEach(entry => {
    // Log FCP to console in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`${entry.name}: ${entry.startTime}ms`);
    }
    // Send to analytics in production
    if (process.env.NODE_ENV === 'production' && window.gtag) {
      window.gtag('event', entry.name, {
        value: Math.round(entry.startTime),
        metric_id: entry.name.toLowerCase()
      });
    }
  });
});

observer.observe({ entryTypes: ['paint', 'largest-contentful-paint'] });

// Mount app and remove loading screen
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider> {/* Wrap App with HelmetProvider */}
      <App />
    </HelmetProvider>
  </StrictMode>
);

// Remove loading screen after a short delay
setTimeout(removeLoadingScreen, 100);